export const getAccount = `
   query getAccount($id:ID!) {
       getAccount(id:$id) {
         id
         sub
         username
         email
         accountType
         accountStatus
         customerId
       } 
}`;
